import { JsonPipe } from '@angular/common'
import { Component, inject, signal } from '@angular/core'
import { rxResource } from '@angular/core/rxjs-interop'
import { OrdersService } from 'src/app/core/services/orders/orders.service'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { CalendarRangeSelectorComponent } from 'src/app/shared/components/form-elements/calendar-range-selector/calendar-range-selector.component'
import { OrdersTableComponent } from 'src/app/shared/components/orders/orders-table/orders-table.component'
import { PaginationDetailComponent } from 'src/app/shared/components/pagination-detail/pagination-detail.component'
import { OrderFilter } from 'src/app/shared/interfaces/orders/orders-filter.interface'
import { Utils } from 'src/app/shared/utilties'

@Component({
    selector: 'sf-orders',
    imports: [CardComponent, PaginationDetailComponent, OrdersTableComponent, CalendarRangeSelectorComponent, JsonPipe],
    templateUrl: './orders.component.html',
    styleUrl: './orders.component.scss',
})
export class OrdersComponent {
    #ordersService = inject(OrdersService)

    today = new Date()

    #filter = signal<OrderFilter>({
        from: Utils.getDateFirstOfTheMonth(),
        to: this.today.toISOString(),
        pageNumber: 1,
        pageSize: 20,
    })

    filter = this.#filter.asReadonly()

    #orders = rxResource({
        request: () => this.#filter(),
        loader: ({ request }) => this.#ordersService.getOrdersPaged(request),
    })

    orders = this.#orders.asReadonly()

    onPageChanged(pageNumber: number): void {
        this.#filter.update((current) => ({ ...current, pageNumber }))
    }

    onDateChanged(range: { from: string | null; to: string | null }): void {
        this.#filter.update((current) => ({ ...current, ...range }))
    }
}
